import { Injectable } from '@angular/core';

interface ILoggerInterface {
    group(...args: any[]): void;
    log(...args: any[]): void;
    warn(...args: any[]): void;
    assert(...args: any[]): void;
    error(...args: any[]): void;
    table(...args: any[]): void;
}

const _M = 'Logs are disabled';

@Injectable()
export class $ILogger implements ILoggerInterface {
    private _t = true;

    constructor() { }

    public log = (...args: any[]) => this._t ? console.log(...args) : this._BlockConsoleMessages();
    public warn = (...args: any[]) => this._t ? console.warn(...args) : this._BlockConsoleMessages();
    public assert = (...args: any[]) => this._t ? console.assert(...args) : this._BlockConsoleMessages();
    public error = (...args: any[]) => this._t ? console.error(...args) : this._BlockConsoleMessages();
    public table = (...args: any[]) => this._t ? console.table(...args) : this._BlockConsoleMessages();
    public group = (...args: any[]) => this._t ? console.group(...args) : this._BlockConsoleMessages();

    private _BlockConsoleMessages = () => console.log(_M);
}
